import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { selectMenuCategory } from '../../redux/menu-category/menu-category.selector';

import CategoryCollection from '../category-collections/category-collections.components';
import CategoryItem from '../category-item/category-item.component';


import './menu-collections.style.css';

class menuCollection extends React.Component {

    componentDidMount() {
        const menuCategories = this.props.menuCategories;

        window.addEventListener('scroll', () => {
            var top = window.pageYOffset;

            if (document.getElementById("menunav") && (document.getElementsByClassName("shrink")) && (document.getElementsByClassName("names"))) {

                var shrink = document.getElementsByClassName("shrink");
                var names = document.getElementsByClassName("names");


                var i;
                var height = 548;
                if (menuCategories) {
                    menuCategories.map((category, index) => {

                        if (document.getElementById(category.category.split(' ').join('')) && document.getElementById(category.category.split(' ').join('')).clientHeight) {
                            height = height + document.getElementById(category.category.split(' ').join('')).clientHeight;
                        }

                        if (top > height) {
                            document.getElementById("menunav").scrollLeft = (index) * 90;
                        }
                        else {
                            document.getElementById("menunav").scrollLeft = document.getElementById("menunav").scrollLeft - 10;
                        }
                    });
                }

            }
        })
    }

    render() {
        const { menuCategories } = this.props;
        return (
            <div >
                {/* <div className="menu-text" id="menu-text" uk-sticky="offset: 0; top:0;"><h4>Menu</h4></div> */}
                <div style={{ width: "100%", display: "inline-block", position: "absolute", top: "0", left: "0" }}>
                    <div id="menunav" className="uk-navbar-container scrll" uk-navbar="true" uk-sticky="offset: 60; top:0;">
                        <ul className="uk-navbar-nav" data-uk-scrollspy-nav="cls:colorchange; scroll: true;closest:a;offset:105">
                            {menuCategories &&
                                menuCategories.map((category) => (
                                    <li key={category.cat_id} className="menu-collections-li">
                                        <a className='uk-padding-remove menu-collections-a' href={`#${category.category.split(' ').join('')}`}>
                                            <i className="menu-collections-i fas fa-caret-up fa-3x"></i>
                                            <span className="bottomLine" ></span>
                                            <CategoryCollection name={category.category} image_url={category.img} />
                                        </a>
                                    </li>
                                ))}
                        </ul>
                    </div>
                </div>
                <div>
                    {menuCategories &&
                        menuCategories.map(({ cat_id, ...otherprops }) => (
                            <CategoryItem key={cat_id} id={cat_id} {...otherprops} />
                        ))
                    }
                </div>
            </div>
        )
    }
}

const mapStateToProps = createStructuredSelector({
    menuCategories: selectMenuCategory,
})

export default connect(mapStateToProps)(menuCollection);